import { SidebarNavigationItem } from './SidebarNavigationItem';
import { useNavigationItems } from '..';
import { COMPANY } from '@/shared/config';
import { useTranslation } from 'react-i18next';

const SidebarNavigation = () => {
  const { t } = useTranslation();
  const { navItems, activeNavItem } = useNavigationItems();

  return (
    <div className="bg-secondary-bg h-full z-1 space-y-[3rem] px-[1.2rem] pb-[1.2rem] pr-[2.2rem] flex flex-col">
      <div className="space-y-[0.8rem] flex-1">
        {navItems.map(item => (
          <SidebarNavigationItem
            key={item.label}
            isActive={
              item.href === activeNavItem ||
              Boolean(item.activePatterns?.includes(activeNavItem))
            }
            {...item}
          />
        ))}
      </div>

      <div className="flex flex-col gap-[0.4rem] pl-[1.2rem] pb-[1.2rem]">
        <div className="flex items-center gap-[0.4rem]">
          <img
            src="/assets/f2ex-logo-small.svg"
            alt="F2EX"
            className="w-[1.8rem] h-[1.8rem]"
          />

          <span className="headline4 text-primary">{COMPANY.name}</span>
        </div>

        <span className="medium6 text-secondary">© {t('rightsReserved')}</span>
      </div>
    </div>
  );
};

export { SidebarNavigation };
